module.exports = __webpack_public_path__ + "create/static/media/logo.1c530a15.png";


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Footer/Logo/logo.png
// module id = 351
// module chunks = 39